module.exports = __webpack_public_path__ + "static/media/c1.dd651f5e.jpg";